<script setup lang="ts">
import { useRoute } from 'vue-router'
import NavigationMenu from '@/components/NavigationMenu.vue'
import { ref, watch } from 'vue'

const route = useRoute()
// 使用响应式变量动态更新菜单显示状态
const showMenu = ref(false)

// 初始化菜单显示状态
const updateMenuVisibility = () => {
  showMenu.value = !['/', '/login'].includes(route.path)
  console.log('路由路径:', route.path, '是否显示菜单:', showMenu.value)
}

// 初始化时更新
updateMenuVisibility()

// 监听路由变化
watch(() => route.path, () => {
  updateMenuVisibility()
})
</script>

<template>
  <div class="app-layout">
    <NavigationMenu v-if="showMenu" />
    <div class="main-content">
      <router-view />
    </div>
    <div class="footer" v-if="showMenu">
      <p>备案号：浙ICP备2025193342号</p>
    </div>
  </div>
</template>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  padding: 20px;
}

.footer {
  text-align: center;
  padding: 20px;
  margin-top: 40px;
  color: #666;
  font-size: 14px;
  border-top: 1px solid #eee;
}
</style>